
		import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
export const title = "What happened to RSS?";
export const image = "/blog-images/rss_cover.jpg";
export const tags = ["Opinion"];
export const description = "A look at RSS’s rise, decline, and potential resurgence as people seek a simpler, curated web.";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    img: "img",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/rss_cover.jpg",
        alt: "A BlackBerry Storm2 displaying this blog's RSS feed via its' built-in reader"
      })
    }), "\n", _jsxs("cap", {
      children: [_jsxs("subt", {
        children: [_jsx("span", {
          class: "material-symbols",
          children: "info"
        }), "Image credit: Me."]
      }), _jsx("br", {}), _jsxs("subt", {
        children: ["Canon EOS 550D + 50mm f/1.4 | 1/125s | ISO 100 | ", _jsx(_components.a, {
          href: "/blog-images/rss-cover-fullsize.jpg",
          children: "View full-size image."
        })]
      })]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Note: I do plan on posting on this blog more often now. I'm not exactly good at it right now, but it'll get better over time."
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["I was recently working on adding an ", _jsx(_components.a, {
        href: "/feed.xml",
        children: "RSS feed"
      }), " to this newly-moved blog, and I couldn't help but notice that less and less sites had RSS feeds as time went on. Now, I personally grew up mostly in a post-RSS world, but I do remember the tail end of its popularity."]
    }), "\n", _jsx(_components.h2, {
      children: "Origins"
    }), "\n", _jsx(_components.p, {
      children: "The early internet was very sparse, as search engines were far less advanced as they are today. I mean, think back to the last time you actually used a bookmark instead of either using Google or letting your browser's history autocomplete do most of the work. RSS was created so you could keep a tab on your favourite blog, and its ability to attach files even gave birth to podcasting! (Whether that was a good or bad thing is up to you.) Nonetheless, RSS was popular enough that most blogs used it and most blogging software supported it."
    }), "\n", _jsx(_components.h2, {
      children: "Decline"
    }), "\n", _jsx(_components.p, {
      children: "Social media has been around for around as long as RSS has been. In fact, many social media platforms offered RSS feeds, so you could check up on what your friends or the people you followed were up to. This all changed with the advent of the algorithmic timeline, shifting the focus from connecting with others to consuming content. Many social media platforms quietly removed their RSS feeds in the early 2010s."
    }), "\n", _jsx(_components.p, {
      children: "The decline can also be attributed to people starting to get their news exclusively from social media platforms and other algorithmic news feeds such as Flipboard or Google News. This meant that people no longer needed to subscribe to individual blogs or news sites, as they had all their information fed to them by the machine."
    }), "\n", _jsx(_components.h2, {
      children: "Rebirth?"
    }), "\n", _jsx(_components.p, {
      children: "From the late 2010s, and especially in the mid 2020s, there's been a resurgence in desire for a return to a simpler web. To put it simply, people are tired of the current meta. With the advent of LLMs skewing the share of human to nonhuman content on social media, people yearn for a time when the web was a place for humans to connect with each other, not slop farms. RSS perfectly fits into this vision, because it allows users to curate their own experience on the net without relying on algorithms dictating what they should see."
    }), "\n", _jsx(_components.p, {
      children: "So, who knows? Maybe we'll all be using RSS again in a couple years."
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	